<template>
<!-- 城市-汇付账户 基本信息 -->
    <el-dialog :visible.sync="show" width="70%" append-to-body :before-close="closeDialog" :close-on-click-modal="false">
        <div class="form-box" id="form-box">
            <el-form
                ref="form"
                :model="submit_data"
                label-width="180px"
                style="overflow-y: auto; width: 100%; height: 50vh; margin-top: 20px"
            >
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="企业用户名称:">
                            <el-input
                                v-model="submit_data.regName"
                                :placeholder="submit_rules.regName.placeholder"
                                style="width: 220px; margin-right: 5px"
                            >
                            </el-input>
                        </el-form-item>
                        <el-form-item label="营业执照编号:">
                            <el-input
                                v-model="submit_data.licenseCode"
                                :placeholder="submit_rules.licenseCode.placeholder"
                                style="width: 220px; margin-right: 5px"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="证照有效期类型:">
                            <el-select
                                v-model="submit_data.licenseValidityType"
                                :placeholder="submit_rules.licenseValidityType.placeholder"
                                style="width: 220px; margin-right: 20px"
                                clearable
                            >
                                <el-option label="长期有效" value="1"> </el-option>
                                <el-option label="非长期有效" value="0"> </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="经营简称:">
                            <el-input
                                v-model="submit_data.shortName"
                                :placeholder="submit_rules.shortName.placeholder"
                                style="width: 220px; margin-right: 5px"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="证照有效期起始日期:">
                            <el-date-picker
                                format="yyyy-MM-dd"
                                value-format="yyyyMMdd"
                                v-model="submit_data.licenseBeginDate"
                                type="date"
                                :placeholder="submit_rules.licenseBeginDate.placeholder"
                            >
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="证照有效期结束日期:">
                            <el-date-picker
                                format="yyyy-MM-dd"
                                value-format="yyyyMMdd"
                                v-model="submit_data.licenseEndDate"
                                type="date"
                                :placeholder="submit_rules.licenseEndDate.placeholder"
                            >
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <!-- 示例值：310000 -->
                        <el-form-item label="注册地址(省):">
                            <el-select
                                clearable
                                filterable
                                v-model="submit_data.regProvId"
                                placeholder="请选择省"
                                style="width: 220px"
                                @visible-change="getDistrict('sheng')"
                            >
                                <el-option v-for="(item, index) in regProvIdArray" :key="index" :label="item.name" :value="item.adcode"> </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="注册地址(市):">
                            <el-select
                                @visible-change="getDistrict('shi')"
                                clearable
                                filterable
                                v-model="submit_data.regAreaId"
                                placeholder="请选择市"
                                style="width: 220px"
                            >
                                <el-option v-for="(item, index) in regAreaIdArray" :key="index" :label="item.name" :value="item.adcode"> </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="12">
                        <el-form-item label="注册地址(区):">
                            <el-select
                                @visible-change="getDistrict('qu')"
                                clearable
                                filterable
                                v-model="submit_data.regDistrictId"
                                placeholder="请选择区"
                                style="width: 220px"
                            >
                                <el-option v-for="(item, index) in regDistrictIdArray" :key="index" :label="item.name" :value="item.adcode">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="注册地址(详细信息):">
                            <el-input
                                v-model="submit_data.regDetail"
                                :placeholder="submit_rules.regDetail.placeholder"
                                style="width: 220px; margin-right: 5px"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="法人姓名:">
                            <el-input
                                v-model="submit_data.legalName"
                                :placeholder="submit_rules.legalName.placeholder"
                                style="width: 220px; margin-right: 5px"
                            >
                            </el-input>
                        </el-form-item>
                        <el-form-item label="法人证件类型:">
                            <el-select
                                v-model="submit_data.legalCertType"
                                :placeholder="submit_rules.legalCertType.placeholder"
                                style="width: 220px; margin-right: 20px"
                                clearable
                            >
                                <el-option label="身份证" value="00"> </el-option>
                                <el-option label="护照" value="01"> </el-option>
                                <el-option label="军官证" value="02"> </el-option>
                                <el-option label="其他" value="07"> </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="法人证件号码:">
                            <el-input
                                v-model="submit_data.legalCertNo"
                                :placeholder="submit_rules.legalCertNo.placeholder"
                                style="width: 220px; margin-right: 5px"
                            >
                            </el-input>
                        </el-form-item>
                        <el-form-item label="法人证件有效期类型:">
                            <el-select
                                v-model="submit_data.legalCertValidityType"
                                :placeholder="submit_rules.legalCertValidityType.placeholder"
                                style="width: 220px; margin-right: 20px"
                                clearable
                            >
                                <el-option label="长期有效" value="1"> </el-option>
                                <el-option label="非长期有效" value="0"> </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="法人证件有效期开始日期:">
                            <el-date-picker
                                format="yyyy-MM-dd"
                                value-format="yyyyMMdd"
                                v-model="submit_data.legalCertBeginDate"
                                type="date"
                                :placeholder="submit_rules.legalCertBeginDate.placeholder"
                            >
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="法人证件有效期截止日期:">
                            <el-date-picker
                                format="yyyy-MM-dd"
                                value-format="yyyyMMdd"
                                v-model="submit_data.legalCertEndDate"
                                type="date"
                                :placeholder="submit_rules.legalCertEndDate.placeholder"
                            >
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="联系人姓名:">
                            <el-input
                                v-model="submit_data.contactName"
                                :placeholder="submit_rules.contactName.placeholder"
                                style="width: 220px; margin-right: 5px"
                            >
                            </el-input>
                        </el-form-item>
                        <el-form-item label="联系人手机号:">
                            <el-input
                                v-model="submit_data.contactMobile"
                                :placeholder="submit_rules.contactMobile.placeholder"
                                style="width: 220px; margin-right: 5px"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12"> </el-col>
                </el-row>
            </el-form>
            <!-- 对话框底部按钮 -->
            <div style="display: flex; justify-content: center; margin-top: 20px">
                <submitBtn
                    @onSubmitDig="onSubmitDig"
                    :data="submit_data"
                    :rules="submit_rules"
                    :url="submit_url"
                    :JSON_Boolean="false"
                ></submitBtn>
                <el-button @click="closeDialog">关闭</el-button>
            </div>
        </div>
    </el-dialog>
</template>
<script>
var _this;
import axios from 'axios'; // AJAX封装类
import { config } from '@/utils/config'; //配置

export default {
    props: {
        isShow: Boolean,
        data: ''
    },
    watch: {
        isShow(newDate, oldData) {
            _this.show = true;
    
        }
    },
    data() {
        return {
            show: false,
            submit_url: '/huifu/add',
            regProvIdArray: [], // 省数组
            regAreaIdArray: [], // 市数组
            regDistrictIdArray: [], // 区域数组
            adcode: '',

            // 表单数据
            submit_data: {
                regName: '',
                licenseCode: '',
                licenseValidityType: '',
                shortName: '',
                licenseBeginDate: '',
                licenseEndDate: '',
                regProvId: '',
                regAreaId: '',
                regDistrictId: '',
                regDetail: '',
                legalName: '',
                legalCertType: '',
                legalCertNo: '',
                legalCertValidityType: '',
                legalCertBeginDate: '',
                legalCertEndDate: '',
                contactName: '',
                contactMobile: ''
            },
            submit_rules: {
                regName: {
                    placeholder: '企业用户名称',
                    rules: {
                        required: true,
                        message: '企业用户名称错误',
                        regulation: 'gt_str',
                        rulesData: '0'
                    }
                },

                licenseCode: {
                    placeholder: '营业执照编号',
                    rules: {
                        required: true,
                        message: '营业执照编号错误',
                        regulation: 'gt_str',
                        rulesData: '0'
                    }
                },
                licenseValidityType: {
                    placeholder: '证照有效期类型',
                    rules: {
                        required: true,
                        message: '证照有效期类型未选择',
                        regulation: 'gt_str',
                        rulesData: '0'
                    }
                },
                shortName: {
                    placeholder: '经营简称',
                    rules: {
                        required: false,
                        message: '经营简称错误',
                        regulation: 'gt_str',
                        rulesData: '0'
                    }
                },
                licenseBeginDate: {
                    placeholder: '证照有效期起始日期',
                    rules: {
                        required: true,
                        message: '证照有效期起始日期',
                        regulation: 'gt_str',
                        rulesData: '0'
                    }
                },
                licenseEndDate: {
                    placeholder: '证照有效期结束日期',
                    rules: {
                        required: false,
                        message: '证照有效期结束日期',
                        regulation: 'gt_str',
                        rulesData: '0'
                    }
                },
                regProvId: {
                    placeholder: '注册地址(省)',
                    rules: {
                        required: true,
                        message: '注册地址(省)',
                        regulation: 'gt_str',
                        rulesData: '0'
                    }
                },
                regAreaId: {
                    placeholder: '注册地址(市)',
                    rules: {
                        required: true,
                        message: '注册地址(市)',
                        regulation: 'gt_str',
                        rulesData: '0'
                    }
                },
                regDistrictId: {
                    placeholder: '注册地址(区)',
                    rules: {
                        required: true,
                        message: '注册地址(区)',
                        regulation: 'gt_str',
                        rulesData: '0'
                    }
                },
                regDetail: {
                    placeholder: '注册地址(详细信息)',
                    rules: {
                        required: true,
                        message: '注册地址(详细信息)不能为空',
                        regulation: 'gt_str',
                        rulesData: '0'
                    }
                },
                legalName: {
                    placeholder: '法人姓名',
                    rules: {
                        required: true,
                        message: '法人姓名不能为空',
                        regulation: 'gt_str',
                        rulesData: '0'
                    }
                },
                legalCertType: {
                    placeholder: '法人证件类型',
                    rules: {
                        required: true,
                        message: '法人证件类型不能为空',
                        regulation: 'gt_str',
                        rulesData: '0'
                    }
                },
                legalCertNo: {
                    placeholder: '法人证件号码',
                    rules: {
                        required: true,
                        message: '法人证件号码不能为空',
                        regulation: 'gt_str',
                        rulesData: '0'
                    }
                },
                legalCertValidityType: {
                    placeholder: '法人证件有效期类型',
                    rules: {
                        required: true,
                        message: '法人证件有效期类型不能为空',
                        regulation: 'gt_str',
                        rulesData: '0'
                    }
                },
                legalCertBeginDate: {
                    placeholder: '法人证件有效期开始日期',
                    rules: {
                        required: true,
                        message: '法人证件有效期开始日期不能为空',
                        regulation: 'gt_str',
                        rulesData: '0'
                    }
                },
                legalCertEndDate: {
                    placeholder: '法人证件有效期截止日期',
                    rules: {
                        required: false,
                        message: '法人证件有效期截止日期不能为空',
                        regulation: 'gt_str',
                        rulesData: '0'
                    }
                },
                contactName: {
                    placeholder: '联系人姓名',
                    rules: {
                        required: true,
                        message: '联系人姓名不能为空',
                        regulation: 'gt_str',
                        rulesData: '0'
                    }
                },
                contactMobile: {
                    placeholder: '联系人手机号',
                    rules: {
                        required: true,
                        message: '联系人手机号不能为空',
                        regulation: 'gt_str',
                        rulesData: '0'
                    }
                }
            }
        };
    },
    created() {
        _this = this;
    },

    methods: {

        // 获取省
        getDistrict(val) {
            
            if (val == 'sheng') {
                _this.regProvIdArray = [];
                _this.adcode = '中国';
            }
            if (val == 'shi') {
                _this.regAreaIdArray = [];
                if (_this.submit_data.regProvId == '') {
                    this.$message.error('请先选择省');
                    return;
                }
                _this.adcode = _this.submit_data.regProvId;
            }
            if (val == 'qu') {
                _this.regDistrictIdArray = [];
                if (_this.submit_data.regAreaId == '') {
                    this.$message.error('请先选择市');
                    return;
                }
                _this.adcode = _this.submit_data.regAreaId;
            }

            var opts = {
                subdistrict: 1, //返回下一级行政区
                showbiz: false //最后一级返回街道信息
            };

            var district = new AMap.DistrictSearch(opts); //注意：需要使用插件同步下发功能才能这样直接使用

            district.search(_this.adcode, function (status, result) {
                console.log(result.districtList[0].districtList,'result.districtList[0].districtList');
                if (status == 'complete') {
                    let districtListArr = result.districtList[0].districtList;
                    for (let i = 0; i < districtListArr.length; i++) {
                        if (val == 'sheng') {
                            _this.regProvIdArray.push({name:districtListArr[i].name,adcode:districtListArr[i].adcode});
               
                        }
                        if (val == 'shi') {
                            _this.regAreaIdArray.push({name:districtListArr[i].name,adcode:districtListArr[i].adcode});
                        }
                        if (val == 'qu') {
                            _this.regDistrictIdArray.push({name:districtListArr[i].name,adcode:districtListArr[i].adcode});
                        }
                    }
                }
            });
        },
        // 提交
        onSubmitDig() {
            _this.$emit('onSubmit');
            _this.closeDialog();
        },
        // 关闭方法
        closeDialog() {
            _this.show = false;
            _this.regProvIdArray = [];
            _this.regAreaIdArray = [];
            _this.regDistrictIdArray = [];
            _this.adcode = '';
            _this.submit_data = {
                regName: '',
                licenseCode: '',
                licenseValidityType: '',
                shortName: '',
                licenseBeginDate: '',
                licenseEndDate: '',
                regProvId: '',
                regAreaId: '',
                regDistrictId: '',
                regDetail: '',
                legalName: '',
                legalCertType: '',
                legalCertNo: '',
                legalCertValidityType: '',
                legalCertBeginDate: '',
                legalCertEndDate: '',
                contactName: '',
                contactMobile: ''
            };
        }
    }
};
</script>
<style scoped>
.recharge-btn {
    display: flex;
}
.form-box {
    padding: 20px;
    box-sizing: border-box;
    width: 100%;
}

.recharge-span {
    font-size: 18px;
    margin: 10px 0;
}
</style>
<style>
.recharge-btn .el-button--info {
    border: 1px solid #05c0ab;
    background-color: #fff;
    color: #05c0ab;
}
.form-box .el-image__inner {
    width: 220px;
}
</style>

